import Vue from "vue";
import Organization from "../../../common/models/organization";
import Group from "../../organization_management/models/group";
import Folder from "../models/folder";
import OrganizationDocument from "../models/organizationDocument";
import User from "../../../common/models/user";
import Selected from "../store/modules/selected";
import Application from "../models/application";

export default Vue.extend({
  data: function () {
    return {
      interfaceStoreState: this.$store.state.interfaceStore,
      organizationStoreState: this.$store.state.organizationStore,
    };
  },
  computed: {
    user(): User {
      return Selected.currentUser.get();
    },
    organization: {
      get(): Organization {
        return Selected.organization.get();
      }
    },
    selectedFolder: {
      get(): Folder {
        return Selected.folder.get();
      }
    },
    selectedContextFolder: {
      get(): Folder {
        return Selected.contextFolder.get();
      }
    },
    selectedGroup: {
      get(): Group {
        return Selected.group.get();
      }
    },
    movingToFolder: {
      get(): Folder {
        return Selected.movingToFolder.get();
      }
    },
    selectedDocument: {
      get(): OrganizationDocument {
        return Selected.document.get();
      }
    },
    selectedApplication: {
      get(): Application {
        return Selected.application.get();
      }
    },
    currentDragItem() {
      return this.interfaceStoreState.currentDragItem;
    },
    somethingIsMoving() {
      return this.organizationStoreState?.moving
    },
  }
});